<template>
    <div class="pr ath-breadcrumbs breadcrumb-list"
        :class="['sp-' + uiPadding]"
        v-mead-scroll-fade-horizontal
        @wheel="onMouseWheel">
        <nav class="f fh fa-c">
            <ul class="f fh">
                <li v-for="obj in breadcrumbs" :key="obj.uid" class="f fa-c fh">
                    <AthButton v-if="clickable"
                        class="el--inline el--transparent el--s-s"
                        :lbl="obj.name"
                        @click="onClick($event, obj)" />
                    <span v-else>{{ obj.name }}</span>
                    <i v-if="!obj.last" class="lnr-chevron-right"></i>
                </li>
            </ul>
            <hr class="fg el--separator" v-if="uiSeparator" />
        </nav>
    </div>
</template>

<script>
import {guuid, isArray, isEmpty} from '@aretheyhappy/utils';
import AthButton from './Button.vue';

const serialize = lst => {
    if (!isArray(lst) || isEmpty(lst)) return [];

    const last = lst[lst.length - 1].name;

    return lst.map(el => Object.assign(el, {uid: guuid(), last: el.name === last}));
};

export default {
    name: 'mead-breadcrumbs-list',
    props: {
        /**
         * The list of breadcrumb entries to render, each expected to have at least
         * a `name` (and optionally `data` used when the crumb is clicked). Pass
         * `false` (or an empty/invalid value) to render no breadcrumbs at all.
         */
        list: {type: [Boolean, Array], default: () => false},
        /**
         * When true, non-final breadcrumbs are rendered as clickable buttons that
         * emit `actSelect` on click; when false they render as plain, inert text.
         */
        clickable: {type: Boolean, default: () => true},
        /**
         * Whether to render the horizontal separator line beneath the breadcrumb trail.
         */
        uiSeparator: {type: Boolean, default: () => true},
        /**
         * Size modifier (e.g. 'xxs') controlling the horizontal padding applied to
         * the breadcrumbs container via the `sp-{uiPadding}` class.
         */
        uiPadding: {type: String, default: () => 'xxs'},
    },
    components: {AthButton},
    data () {
        return {
            breadcrumbs: serialize(this.list),
        };
    },
    methods: {
        onClick: function (event, obj) {
            event.preventDefault();
            event.stopPropagation();
            if (obj.last) return;
            this.$emit('actSelect', obj.data);
        },
        onMouseWheel: function (event) {
            if (!event.deltaY) {
                return;
            }

            event.currentTarget.scrollLeft += event.deltaY + event.deltaX;
            event.preventDefault();
        }
    },
    watch: {
        list: function () {
            this.breadcrumbs = serialize(this.list);
        },
    },
}
</script>

<style lang="scss" scoped>
@import '../../../sass/_variables.scss';

.ath-breadcrumbs {
    z-index: 1;
    overflow-y: auto;
}

.el--separator {
    border: none;
    height: 1px;
    background-color: var(--c-panel-border);
    margin: 5px 0;
}

ul {
    margin-bottom: 0;

    li > span {
        font-family: $ff-b;
        font-weight: 400;
        font-size: $fs-xs;
        color: var(--c-txt-light);

        & + i {
            font-size: $fs-xxs;
            padding-inline: $s-xs;
        }
    }
}

.breadcrumb-list {
    // Firefox
    scrollbar-width: none;

    // WebKit-based browsers (Chrome, Safari, Opera):
    &::-webkit-scrollbar {
        display: none;
    }
}

li {
    max-width: 100%;

    &:not(:last-of-type) .el-btn {
        &:hover,
        &:active {
            box-shadow: 0 0 0 1px var(--c-panel-border-active), var(--c-shade-m);
        }
    }

    &:last-of-type .el-btn {
        cursor: default;

        &:active {
            box-shadow: none;
        }
    }
}
</style>
